import { createContext } from "react";
import { io, Socket } from 'socket.io-client';
import { API_BASE_URL } from "../utils/constants";

console.log(API_BASE_URL);
const APIURL = API_BASE_URL?.substring(API_BASE_URL.length - 4, 0)
console.log(APIURL);

export const socket = () => io(APIURL , { transports: ["websocket"], withCredentials: true });
export const SocketContext = createContext<() => Socket>(socket);